import { useEffect, useState } from 'react';
import { Navigate } from 'react-router';

import { Alert } from '@ds/feedback';
import { SURFACES } from '@/router/rotas';
import { autocadastroLigado } from '@/session/autocadastro';
import { atual, contaSemClinica, sair, surfacePermitida } from '@/session/sessao';
import { AceitarConvite } from './criarConta/AceitarConvite';
import { Autocadastro } from './criarConta/Autocadastro';

/**
 * Criar conta: aceitar convite, como sempre, ou — com `VITE_AUTOCADASTRO=1` — o
 * autocadastro com teste e cobrança (0150). A escolha é do build, não da pessoa: o
 * cadastro com pagamento só vai ao ar com os termos publicados e o Asaas liberado.
 *
 * É também para cá que o Google devolve quem entrou por ele. Com o autocadastro
 * desligado: quem já é da equipe tem sessão e segue para dentro; quem voltou com uma
 * conta que nenhuma clínica cadastrou não pode ficar logado numa tela de convite —
 * a sessão é encerrada e a tela diz por quê.
 */
export function CriarConta() {
    const ligado = autocadastroLigado();
    const sessao = atual();
    const [semClinica, setSemClinica] = useState<string | null>(null);

    useEffect(() => {
        if (ligado || sessao) return undefined;
        let vivo = true;
        void contaSemClinica().then(async (conta) => {
            if (!vivo || !conta) return;
            await sair();
            if (vivo) setSemClinica(conta.email);
        });
        return () => { vivo = false; };
    }, [ligado, sessao]);

    if (ligado) return <Autocadastro />;
    if (sessao) return <Navigate to={SURFACES[surfacePermitida()].basePath} replace />;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {semClinica && (
                <Alert tone="warning" dismissible={false} title="Esta conta não tem acesso a nenhuma clínica">
                    A conta <strong>{semClinica}</strong> entrou, mas nenhuma clínica cadastrou este e-mail. Peça para a
                    clínica cadastrá-lo em Configurações › Equipe e entre de novo.
                </Alert>
            )}
            <AceitarConvite />
        </div>
    );
}
